import React, { useEffect, useState } from 'react'

import { Col, Container, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'

import KurzyLayout from './KurzyLayout'
import amaniPointing from '../assets/amani-pointingfingerright.png'
import { useContentWrapper } from '../common/ContentWrapperProvider'
import { money } from '../common/helpers'
import { StyledInfoPageHeaderWrapper } from '../common/styledComponents'
import axios, { SERVER_URL } from '../service/axiosClient'
import { OrderItemCategory } from '../types/OrderItemCategory'
import { OrderItemDto, OrderItemDtoUI } from '../types/OrderItemDto'


function MaterialyPage() {
    const contentWrapper = useContentWrapper()
    const [products, setProducts] = useState<OrderItemDtoUI[]>([])
    const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set())
    const navigate = useNavigate()

    useEffect(() => {
        contentWrapper.setNoBootstrapColumns(true)

        axios.get('/order-item/' + OrderItemCategory.MATERIALY, {}).then(response => {
            console.log('mame data', response.data)

            const tmpMaterialy = response.data || [{isFake: true}]
            // tmpMaterialy.unshift()
            // if (tmpMaterialy.length === 0) {
            //     tmpMaterialy.push({isFake: true}, {isFake: true})
            // } else if (tmpMaterialy.length === 1) {
            //     tmpMaterialy.push({isFake: true})
            // }

            console.log(tmpMaterialy)

            setProducts(tmpMaterialy)
        }).catch(error => {
            console.log('error', error)
        })


        return () => {
            contentWrapper.setNoBootstrapColumns(false)
        }
    }, [])

    const handleProductSelect = (item: OrderItemDto) => {
        localStorage.setItem('selectedProduct', JSON.stringify(item))
        navigate('/kurzy-pokladna')
    }

    return (
        <KurzyLayout>
            <StyledInfoPageHeaderWrapper>
                <Container>
                    <Row>
                        <Col>
                            <h1 className={'font-vollkorn fs-55 color-pink-primary'}>Materiály</h1>
                        </Col>
                    </Row>
                </Container>

            </StyledInfoPageHeaderWrapper>
            <Container>
                <Row>
                    <Col>
                        <div className="kurzy-container">
                            {products.map((item, index) => {
                                return <>
                                    {index === 0 &&
                                        <div><img src={amaniPointing} alt="" className={'w100p'}/></div>}
                                    {item.isFake ?
                                        <></> :
                                        <div className="kurzy-item flex-direction-column" key={item.id}>
                                            <h3 className={'font-vollkorn text-prikavicke-blue mb-2'}>{item.name}</h3>

                                            {expandedItems.has(item.id) ? (
                                                <>
                                                    <div dangerouslySetInnerHTML={{__html: item.moreInfo || ''}}/>
                                                    <div className={'d-flex justify-content-center mt-3'}>
                                                        <button
                                                            onClick={() => handleProductSelect(item)}
                                                            className="btn btn-primary bg-pink-dark btn-amani w-100 d-inline-block text-uppercase">
                                                            chcem kúpiť
                                                        </button>
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="d-flex gap-15 kurzy-item-inner">
                                                    <div className="image-left">
                                                        <img src={`${SERVER_URL}/storage/${item.image}`} alt=""/>
                                                    </div>
                                                    <div className="content-right">
                                                        <div dangerouslySetInnerHTML={{__html: item.description}}/>
                                                        <br/>
                                                        <br/>
                                                        Formát: {item.format}<br/>
                                                        Cena: <strong>{item.price ? money.format(item.price) : 'bezplatne'}</strong>{item.installmentBuying && ' (možnosť úhrady na 3 splátky)'}<br/>
                                                        {item.moreInfo ? (
                                                            <button
                                                                onClick={() => setExpandedItems(prev => new Set(prev).add(item.id))}
                                                                className="btn btn-primary mt-3 bg-pink-dark btn-amani w-100p d-inline-block text-uppercase">
                                                                viac informácií
                                                            </button>
                                                        ) : (
                                                            <button
                                                                onClick={() => handleProductSelect(item)}
                                                                className="btn btn-primary mt-3 bg-pink-dark btn-amani w-100p d-inline-block text-uppercase">
                                                                chcem ju
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            )}

                                        </div>}
                                </>
                            })}

                        </div>
                    </Col>
                </Row>
            </Container>
        </KurzyLayout>
    )
}


export default MaterialyPage